import SelectDocumentTemplateModalController from '../controllers/modals/select-template-modal-controller';
import selectTemplateModalTemplate from '../views/modals/select-template-modal.tpl.html';
import createOverviewModalTemplate from '../views/modals/create-overview-modal.tpl.html';
import CreateOverviewModalController from '../controllers/modals/create-overview-modal-controller';

class DocumentCreateService {
    constructor($injector) {
        this.injector = $injector;
        this.modal = this.injector.get('$uibModal');
        this.depositService = this.injector.get('Deposit');
        this.log = this.injector.get('$log');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.angularState = this.injector.get('$state');
    }

    startNewDocumentWizard(relationType, store, dataForRelated) {
        this._checkRelationType(relationType).then(() => {
            this._openSelectTemplateModal(relationType).then((selectedInformation) => {
                this._openCreateOverviewModal(relationType, selectedInformation.templateId, store).then((model) => {
                    const dataForApi = {
                        document_template_id: selectedInformation.templateId,
                        relation_type: relationType,
                        data: model
                    };
                    dataForApi[relationType] = dataForRelated;

                    return this.api.post(`documents`, dataForApi).then((response) => {
                        this.alert.success(this.translate.instant('documents.services.create-service.alerts.created.title'), this.translate.instant('documents.services.create-service.alerts.created.message'));
                        this.angularState.go('app.documents.main.details', {id: response.data.data.id});

                        return response.data.data;
                    }, (e) => {
                        this.alert.error(this.translate.instant('documents.services.create-service.alerts.create_error.title'), this.translate.instant('documents.services.create-service.alerts.create_error.message'));

                        return e;
                    });
                });
            });
        }, () => {
            this.log.error('Invalid relation Type', relationType);
        });
    }

    startNewSingleDocumentWizard(relationType, dataForRelated) {
        this._checkRelationType(relationType).then(() => {
            this._openSelectTemplateModal(relationType).then((selectedInformation) => {
                this._openCreateOverviewModal(relationType, selectedInformation.templateId, null).then((model) => {
                    const dataForApi = {
                        document_template_id: selectedInformation.templateId,
                        relation_type: relationType,
                        data: model
                    };
                    dataForApi[relationType] = dataForRelated;

                    return this.api.post(`documents`, dataForApi).then((response) => {
                        this.alert.success(this.translate.instant('documents.services.create-service.alerts.created.title'), this.translate.instant('documents.services.create-service.alerts.created.message'));
                        this.angularState.go('app.documents.main.details', {id: response.data.data.id});

                        return response.data.data;
                    }, (e) => {
                        this.alert.error(this.translate.instant('documents.services.create-service.alerts.create_error.title'), this.translate.instant('documents.services.create-service.alerts.create_error.message'));

                        return e;
                    });
                });
            });
        }, () => {
            this.log.error('Invalid relation Type', relationType);
        });
    }

    _openSelectTemplateModal(relationType) {
        return this.modal.open({
            controller: SelectDocumentTemplateModalController,
            controllerAs: 'vm',
            templateUrl: selectTemplateModalTemplate,
            resolve: {
                relationType: () => {
                    return relationType;
                }
            }
        }).result;
    }

    _openCreateOverviewModal(relationType, selectedTemplateId, store) {
        return this.modal.open({
            controller: CreateOverviewModalController,
            controllerAs: 'vm',
            templateUrl: createOverviewModalTemplate,
            resolve: {
                relationType: () => {
                    return relationType;
                },
                selectedTemplate: () => {
                    return this.api.get(`documents/templates/${selectedTemplateId}`).then((response) => {
                        return _.get(response, 'data.data');
                    }, (e) => {
                        return e;
                    });
                },
                store: () => {
                    return store;
                }
            }
        }).result;
    }

    _checkRelationType(relationType) {
        return new Promise((resolve, reject) => {
            this.depositService.getRemoteDeposit('documents', 'template_relation_types').then((availableRelationTypes) => {
                if (!_.isUndefined(availableRelationTypes[relationType])) {
                    resolve();
                } else {
                    reject();
                }
            }, () => {
                this.log.error('Can not load available relation type');
                reject();
            })
        })
    }
}

angular
    .module('festzelt-os.modules.documents')
    .factory('DocumentCreateService', [
        '$injector',
        ($injector) => new DocumentCreateService($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/documents/services/document-create-service.js